import * as http from './http';
import ApiService from './service';
import { ApiResponse, ListSort, PaginatedApiResponse } from '../models';
import { Dict } from '../../models';
import { FinanceLPO, LeadConfiguration } from '../models/configuration';
import { stringify } from 'query-string';

export class FinanceService extends ApiService {
  public async getFinances(
    data: {
      page: number;
      search?: string;
      perPage: number;
    } & ListSort &
      Dict
  ): Promise<
    PaginatedApiResponse<LeadConfiguration> & { lastUpdatedAt: Date }
  > {
    const url = `${this.apiDomain}/api/finance/list`;
    const response = await http.post<PaginatedApiResponse<LeadConfiguration>>(
      url,
      data,
      this.store
    );
    return { ...response?.data, lastUpdatedAt: new Date() };
  }

  public async getFinanceDetails(data: {
    leadId: string;
    configId: string;
  }): Promise<LeadConfiguration> {
    const url = `${this.apiDomain}/api/finance?${stringify(data)}`;
    const response = await http.get<ApiResponse<LeadConfiguration>>(
      url,
      this.store
    );
    return response?.data?.data;
  }

  public async attachFinance(data: {
    leadId: string;
    configId: string;
  }): Promise<void> {
    const url = `${this.apiDomain}/api/finance/attach`;
    const response = await http.put<ApiResponse<void>>(url, data, this.store);
    return response?.data?.data;
  }

  public async detachFinance(data: {
    leadId: string;
    configId: string;
  }): Promise<void> {
    const url = `${this.apiDomain}/api/finance/detach`;
    const response = await http.put<ApiResponse<void>>(url, data, this.store);
    return response?.data?.data;
  }

  public async uploadLPO(data: {
    leadId: string;
    configId: string;
    lpo: FinanceLPO;
  }): Promise<void> {
    const url = `${this.apiDomain}/api/finance/lpo`;
    const response = await http.post<ApiResponse<void>>(url, data, this.store);
    return response?.data?.data;
  }

  public async updateLPO(data: {
    leadId: string;
    configId: string;
    lpo: FinanceLPO;
  }): Promise<void> {
    const url = `${this.apiDomain}/api/finance/lpo`;
    const response = await http.put<ApiResponse<void>>(url, data, this.store);
    return response?.data?.data;
  }

  public async withdrawLPO(data: {
    leadId: string;
    configId: string;
  }): Promise<void> {
    const url = `${this.apiDomain}/api/finance/lpo/withdraw`;
    const response = await http.put<ApiResponse<void>>(url, data, this.store);
    return response?.data?.data;
  }

  public async rejectFinance(data: {
    leadId: string;
    configId: string;
    comment?: string;
  }): Promise<void> {
    const url = `${this.apiDomain}/api/finance/reject`;
    const response = await http.put<ApiResponse<void>>(url, data, this.store);
    return response?.data?.data;
  }

  public async holdFinance(data: {
    leadId: string;
    configId: string;
    comment?: string;
  }): Promise<void> {
    const url = `${this.apiDomain}/api/finance/hold`;
    const response = await http.put<ApiResponse<void>>(url, data, this.store);
    return response?.data?.data;
  }

  public async sendFinanceReminder(data: {
    leadId: string;
    configId: string;
    comment?: string;
  }): Promise<void> {
    const url = `${this.apiDomain}/api/finance/reminder`;
    const response = await http.put<ApiResponse<void>>(url, data, this.store);
    return response?.data?.data;
  }
}
